const Url = {
    Login: {
        CHECK_LOGIN: "hmfs/login/check-login",
        CAPTCHA: "hmfs/login/captcha/",
        SEND_OTP: "hmfs/login/send-otp/",
        CHANGE_PWD: "hmfs/login/change-password"
    },
    NOC: {
        SAVE_NOC: "hmfs/noc/save-noc",
        GET_DESIGNATION: "hmfs/noc/get-designation",
        GET_DEPT: "hmfs/noc/get-department",
        GET_NOC_STATUS: "hmfs/noc/get-noc-status/",
        GET_NOC_ID: "hmfs/noc/get-noc-id/",
        GET_NOC_PASS: "hmfs/noc/get-noc-pass/",
        GET_PENDING_NOC: "hmfs/noc/get-noc-pending/",
        SAVE_NOC_APPROVAL: "hmfs/noc/save-noc-approval",
        HISTORY_NOC: "hmfs/noc/get-history/",
        DOWNLOAD_PDF_BLOB: "hmfs/noc/get-history/",
        DOWNLOAD_PDF_FOR_VF: "hmfs/noc/getPdfDocument/",
        DOWNLOAD_PDF_FOR_HOD: "hmfs/noc/getPdfDocumentForHOD/",
        DOWNLOAD_PDF_FOR_RETURN: "hmfs/noc/getPdfDocumentForReturn/"
    },
    WF: {
        GET_ACTION: "hmfs/wf/action-for-task/",
        GET_APPROVED_LIST: "hmfs/wf/approvedList/",
        DASHBOARD_ACTION: "hmfs/wf/get-stats"
    },
    DOC: {
        UPLOAD_FILE: "doc/upload/",
        DOWNLOAD_FILE: "doc/file-blob/"
    }

}

export default Url;